// Matches `border: 2px` on .page, .stack and .dashed in Node.module.scss; the
// ghost variant draws no border.
export const NODE_BORDER_WIDTH = 2
